import { routes } from 'data/routes';

import { Button } from 'components/Button';
import { Filters } from 'components/Filters';
import { Headline } from 'components/Headline';
import { Table } from 'components/Table';

import * as S from './Deleted.styles';
import { useDeleted } from './useDeleted';

export const Deleted = () => {
  const {
    deletedUsers,
    register,
    setValue,
    control,
    reset,
    filters,
    columns,
    onSubmit,
    handleSubmit,
    isLoading,
    params,
  } = useDeleted();

  return (
    <>
      <Filters
        title="Deleted users"
        reset={reset}
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        filters={filters}
        control={control}
        setValue={setValue}
        isLoading={isLoading}
        defaultValues={params}
      />

      <Table
        motive="m3"
        isLoading={isLoading}
        columns={columns}
        data={deletedUsers}
        hasPagination
        hasSort
        hasApiSorting
      />

      {!deletedUsers ? (
        <S.Container>
          <Headline fontFamily="LFT Zeno Condensed" scale="xl">
            Nothing is in the “Deleted users”
          </Headline>

          <p>At this time, there are no deleted users.</p>

          <S.Image />

          <Button
            textTransform="uppercase"
            to={routes.users}
            fontFamily="LFT Zeno Condensed"
            motive="addNew"
          >
            Back to users
          </Button>
        </S.Container>
      ) : null}
    </>
  );
};
